import { Component, OnInit, ViewChild } from '@angular/core';
import { IMessage } from 'src/app/shared/interfaces/message';
import { ISearchBody } from 'src/app/shared/interfaces/searchBody';
import { FakeDataService } from 'src/app/shared/mock/fake-data.service';
import { ModalComponent } from 'src/app/shared/modals/modal.component';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrl: './message.component.css'
})
export class MessageComponent implements OnInit {

  drId: any = 7;

  @ViewChild('modal') modal!: ModalComponent;

  messagesList: IMessage[];
  searchInp: ISearchBody = {
    id: this.drId, 
    title: '', 
    pageSize: 0, 
    pageIndex: 0
  };
  showMessage: IMessage;

  messageStatus = [
    {title:'خوانده شده' , value:2},
    {title:'خوانده نشده' , value:1},
  ]

  constructor(
    private apiService: ApiService,
    private fakeDataService: FakeDataService){}


  ngOnInit(): void {
    this.getMessages();
    
  }

  getMessages() {
    // this.fakeDataService.getMessages().subscribe((res: IMessage[]) => {
    //   this.messagesList = res;
    // })

    this.apiService.apiCall('get', '/api/Doctor/GetAllDoctorMessage').subscribe((res: any) => {
      console.log(res);
       this.messagesList = res.body.model;
    })
  }

  seeMessage(msgId) {
    this.apiService.apiCall('post', '/api/Doctor/SeeMessage/'+msgId).subscribe((res: any) => {
      console.log(res);
      
    })
  }

  // test(data) {
  //   this.showMessage = data;
  //   this.modal.open();
  //   console.log(data);
  // }


}
